import { ListPageTitles } from "../../utils/navigation/pageTitles";
import { WasteMovementDefaultsPage } from "../WasteMovementDefaultsPage/WasteMovementDefaultsPage";

const WasteReceivedDefaultsPage = () => (
    <WasteMovementDefaultsPage
        config={{
            movementDirection: "Received",
            listTitle: ListPageTitles.wasteReceived,
            listPath: "/waste-received",
            defaultsPath: "/waste-received/defaults",
            siteStorageKey: "WasteReceivedDefaultsPage.siteId",
        }}
    />
);

export { WasteReceivedDefaultsPage };
